import { Box, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.grey[400],
    fontWeight: 400,
    fontSize: '16px',
    marginTop: '40px',
  },
}));

const EmptyView: React.FC = () => {
  const { root } = useStyles();
  return (
    <Box
      data-testid="active-chat-empty"
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
      flexDirection="column"
    >
      <svg
        width="104"
        height="104"
        viewBox="0 0 104 104"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M52.8587 81.0921L34.1369 96.1714L34.1321 96.1753C30.5432 99.1437 25.1166 96.5872 25.1166 91.9272V80.7238H15.7788C8.63448 80.7238 2.84766 74.9286 2.84766 67.7857V34.3572C2.84766 28.0952 7.29079 22.8775 13.1959 21.6779C15.1727 21.2764 17.1007 22.5533 17.5023 24.5301C17.9039 26.5069 16.6269 28.4349 14.6501 28.8365C12.0858 29.3574 10.1524 31.6333 10.1524 34.3572V67.7857C10.1524 70.8995 12.6739 73.4191 15.7788 73.4191H26.9132C29.958 73.4191 32.4214 75.8885 32.4214 78.9286V88.1737L48.224 75.4455L48.7213 75.0275C50.2654 73.7295 52.5693 73.929 53.8673 75.4731C55.1652 77.0172 54.9657 79.3211 53.4217 80.6191L52.8587 81.0921ZM52.2652 69.0641L52.2409 69.0437C51.226 68.1912 49.943 67.7238 48.6175 67.7238H34.3572C27.2117 67.7238 21.4191 61.9313 21.4191 54.7857V21.3572C21.4191 14.2117 27.2117 8.41907 34.3572 8.41907H86.3572C93.5027 8.41907 99.2953 14.2116 99.2953 21.3572V54.7857C99.2953 61.9313 93.5027 67.7238 86.3572 67.7238H78.8667V78.9168C78.8667 83.5811 73.4383 86.1275 69.8529 83.1683L69.8476 83.1639L52.2652 69.0641ZM34.3572 15.7238C31.246 15.7238 28.7238 18.246 28.7238 21.3572V54.7857C28.7238 57.8969 31.246 60.4191 34.3572 60.4191H48.6175C51.6467 60.4191 54.5793 61.4819 56.9047 63.4215L71.5619 75.1754V65.9286C71.5619 62.8858 74.0286 60.4191 77.0715 60.4191H86.3572C89.4684 60.4191 91.9905 57.8969 91.9905 54.7857V21.3572C91.9905 18.246 89.4684 15.7238 86.3572 15.7238H34.3572Z"
          fill="#E4E4E7"
        />
      </svg>
      <Typography className={root}>
        <FormattedMessage
          id="ActiveChat.noActiveChat"
          defaultMessage="No active chat selected"
        />
      </Typography>
    </Box>
  );
};

export default EmptyView;
